export default {
  title: 'Visão geral',
  table_title: 'Reservas',
  filters: {
    card_title: 'Filtros',
    today: 'Hoje',
    upcoming: 'Próximas',
    past: 'Passadas',
    all: 'Todas',
    all_dates: 'Todo o período',
    pending: 'Confirmação pendente',
    canceled: 'Cancelada',
    removed: 'Removida',
    date_label: 'Data:',
    status_label: 'Estado:',
    source_label: 'Origem:',
    source_website: 'Website',
    source_google: 'Google',
    search_label: 'Pesquisa:',
    search_placeholder: 'Pesquisar por nome ou apelido',
    custom_date_tooltip: 'Escolher uma data específica',
    active_label: 'Filtros ativos:',
    clear_all: 'Limpar tudo',
  },
  tooltips: {
    total_reservations: 'Total de reservas',
    total_guests: 'Total de convidados',
    refresh: 'Atualizar',
  },
  empty: {
    default: 'Ainda não há reservas.',
    filtered: 'Nenhuma reserva corresponde aos seus filtros.',
  },
  fields: {
    company: 'Restaurante',
    datetime: 'Data / hora',
    customer: 'Cliente',
    source: 'Origem',
    guests: 'Convidados',
    status: 'Estado',
    created_at: 'Criado em',
  },
  status: {
    confirmed: 'Confirmada',
    pending: 'Aguarda aprovação',
    canceled: 'Cancelada',
    rejected: 'Rejeitada',
    removed: 'Removida',
  },
  buttons: {
    details: 'Detalhes',
    add_reservation: 'Adicionar reserva',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar os dados',
  },
};
